import { styled } from '@mui/material/styles';
import { Box, Typography } from "@mui/material";

export const CountdownContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  columnGap: theme.space._200,
  width: 'fit-content',
  height: '3.125rem',
  position: 'relative',
  zIndex: "1",
}));

export const CountdownDisplayContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: "0.5rem",
  height: "3.125rem",
  width: "3.5rem",
}));

export const CountdownDisplay = styled(Typography)(({ theme }) => ({
  color: theme.colors['neutral.50'],
  fontSize: theme.fontSizes['2xl'],
  fontFamily: theme.fonts.default,
  fontWeight: theme.fontWeights.bold,
}));

export const CountdownLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isDarkText',
})<{ isDarkText?: boolean }>(
  ({ theme, isDarkText }) => ({
    color: isDarkText ? theme.colors['neutral.950'] : theme.colors['neutral.50'],
    fontSize: theme.fontSizes.sm,
    fontFamily: theme.fonts.default,
    fontWeight: theme.fontWeights.medium,
    lineHeight: theme.lineHeights.base,
  })
);

export const SecondaryCountdownDisplayContainer = styled(Typography)(({ theme }) => ({
  backgroundColor: theme.colors['neutral.950'],
  display: 'flex',
  borderRadius: '.5rem'
}));